import React from 'react';
import PropTypes from 'prop-types';
import Paper from 'material-ui/Paper';
import AppBar from 'material-ui/AppBar';
import FlatButton from 'material-ui/FlatButton';
import './Dialog.css'

const styles = {
    barStyle: {
        boxShadow: "none",
        zIndex: "auto"
    },
    titleStyle: {
        height: "48px",
        lineHeight: "48px",
        fontSize: 22,
        textAlign: "center"
    }
};

export default class Dialog extends React.Component {

    static propTypes = {
        title: PropTypes.string,
        showTitleBar: PropTypes.bool,
        className: PropTypes.string,
        actions: PropTypes.arrayOf(PropTypes.object),
    };

    render() {
        let className = 'dialog';

        let title;
        if (this.props.showTitleBar) {
            className += ' dialog-with-bar';
            title = <AppBar className="dialog-bar" title={this.props.title} showMenuIconButton={false} style={styles.barStyle} titleStyle={styles.titleStyle} />;
        } else {
            title = <div className="dialog-title">{this.props.title}</div>;
        }

        let actions = null;
        if (this.props.actions && this.props.actions.length > 0) {
            actions = (
                <div className="dialog-actions">
                    {this.props.actions.map((action, index) => {
                        let props = {
                            label: action.label,
                            ...(action.handler && {onTouchTap: action.handler}),
                            ...(action.disabled && {disabled: action.disabled}),
                            ...(action.primary && {primary: action.primary}),
                            ...(action.secondary && {secondary: action.secondary}),
                            ...(action.type && {type: action.type}),
                            ...(action.form && {form: action.form})
                        };
                        return <FlatButton key={"action-" + index} {...props}/>;
                    })}
                </div>
            );
        }

        if (this.props.className) {
            className += ' ' + this.props.className;
        }

        let content = null;
        if (this.props.children) {
            content = <div className="dialog-content">{this.props.children}</div>;
        }

        return (
            <Paper className={className} transitionEnabled={false} zDepth={3}>
                {title}
                {content}
                {actions}
            </Paper>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/overlay/Dialog.js